// extracted by mini-css-extract-plugin
export var divider = "_qs-0";
export var systemMessage = "_qs-1";